// react, react-redux, redux-form
import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, FormSection } from "redux-form";

// helpers
import { required, percentage, percentageTwoDecimals } from "../../../helpers/validate";
import { fileUploaded } from "../../../helpers/actionsHelpers";
import { formatPercentage, normalizePercentage, jumpToError } from "../../../helpers/renderHelpers";

// redux actions
import { saveAppState } from "../../../actions/appActions";

// enums
import { TYPE_ACTIVITY_LIST } from '../../../config/enums';

// render components
import RenderField from "../../global/RenderField";

// Redux actions
import { getQuoteCall } from "../../../actions/formActions";

class feePayment extends React.Component {

  componentDidMount() {
    if (!this.props.formData.feePayable && this.props.isGetQuote === false && Object.keys(this.props.quoteData).length === 0) {
      this.props.getQuoteCall(this.props.formData, ((process.env.NODE_ENV === "development") ? process.env.REACT_APP_HOST_URL : window.location.origin) + "/_webservices/heritage/permit/fee-payable-quote")
    }
  }
  
  render() {
    const { formData, formName, attachments, handleSubmit, previousPage, saveAppState, appState, isAppSaving, isGetQuote, quoteData } = this.props;

    let feeWaiverPercentage = 0;

    if (formData.feeWaiver && formData.feeWaiver.length > 0) {
      formData.feeWaiver.forEach(item =>
        feeWaiverPercentage += parseFloat(item.percentageOfCost) || 0
      )
    }

    if (Object.keys(quoteData).length > 0) {
      this.props.change(`feePayable`, quoteData.feePayable)
    }

    return (
      <form id={formName} onSubmit={handleSubmit}>
        <div>
          <div className="sq-form-section-description">
              <h2>Fee calculation</h2>
              <h3>Fee payable</h3>
              <p>Heritage permit fees are determined in accordance with the Heritage Regulations 2017.</p>
              <p>If you wish to see how the fee is calculated, you can download the details of the <a href="https://www.heritage.vic.gov.au/__data/assets/word_doc/0019/424162/Heritage_Fees_2019_20.docx">2019/2020 Fee Schedule</a>.</p>
          </div>
          <div className="sq-form-section">
          <ul className="list">
            <li className="list-tile">
              <div className="list-tile-content">
                <div className="list-tile-content">
                  {!formData.feePayable ? appState.service.error.code || appState.service.error.message
                      ? (
                        <div>
                          <p>Fee to be paid: <span style={{fontWeight: '600', fontStyle: 'italic'}}>Could not calculate</span></p>
                            {Array.isArray(appState.service.error.message) ?
                              <p className="sq-form-error">{appState.service.error.code && `${appState.service.error.code}:`} {appState.service.error.message && `${appState.service.error.message[0].message}`}</p> :
                              <p className="sq-form-error">{appState.service.error.code && `${appState.service.error.code}:`} {appState.service.error.message && `${appState.service.error.message}`}</p>
                            }
                          <button type="button" className="sq-form-page-button" onClick={() => this.props.getQuoteCall(formData, ((process.env.NODE_ENV === "development") ? process.env.REACT_APP_HOST_URL : window.location.origin) + "/_webservices/heritage/permit/fee-payable-quote")} disabled={isGetQuote === true}>Get Quote</button>
                        </div>
                      ) : (
                        <p className="loading">Fee to be paid: <span style={{fontWeight: '600', fontStyle: 'italic'}}>Calculating</span></p>
                    ) : (
                    <div>
                      <p>Fee to be paid: <span style={{fontWeight: '600'}}>${formData.feePayable.toLocaleString()}</span></p>
                      { quoteData.regulations && (
                        <div>
                          <p>The fee to be paid has been calculated based off of {quoteData.regulations.length > 1 ? 'these regulations' : 'this regulation'}:</p>
                          <ul>
                            {quoteData.regulations.map( (regulation, i) => { return <li key={i}><span style={{fontWeight: '600'}}>{regulation.code}:</span> {regulation.description}.</li> })}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </li>
          </ul>
          { formData.feePayable && (
            <Field
              name="feeWaiverOrExemption"
              type="radiobox"
              label="It may be possible to apply for a fee waiver or fee exemption of the permit fee for this permit application, please select an option below that is applicable for this permit application."
              templateList={[
                { name: [<span key="1" style={{fontWeight: '600'}}>I am not applying for a fee exemption or waiver.</span>], value: "notApplicable" },
                { name: [<span key="1"><span style={{fontWeight: '600'}}>Fee Exemption:</span> You are exempt from paying this fee if this application relates to a registered place of which you are the owner and which is your principal place of residence, or a registered object which you own, and you must hold either one of the applicable cards for a fee exemption.</span>], value: "exemption" },
                { name: [<span key="1"><span style={{fontWeight: '600'}}>Fee Waiver:</span> If these activities are being undertaken by a community group or for conservation, educational research or public safety, it may be possible to apply for a waiver of the permit fee.</span>], value: "waiver" }
              ]}
              component={RenderField}
              validate={required}
              required
              uncheckable
            />
          )}
          </div>
          { formData.feePayable && formData.feeWaiverOrExemption && formData.feeWaiverOrExemption === 'exemption' && (
            <div>
              <div className="sq-form-section-description">
                <h3>Fee exemption</h3>
              </div>
              <div className="sq-form-section">
                <div className="sq-form-section-description">
                  <ul className="list">
                    <li className="list-tile info">
                      <div className="list-tile-content">
                        <p>You are applying for a fee exemption. To be applicable for a fee exemption you must hold either one of the following cards:</p>
                        <ul className="list-tile-content">
                          <li>A Health care card issued under section 1061Z of the <span style={{fontStyle: 'italic'}}>Social Security Act 1991</span> of the Commonwealth other than in respect of a child in foster care, or a child in respect of whom a carer allowance under section 953 of that Act is payable</li>
                          <li>A Gold Card issued in respect of Part V of the <span style={{fontStyle: 'italic'}}>Veterans' Entitlements Act 1986</span> of the Commonwealth other than a dependant (not including the widow or widower) of a veteran</li>
                          <li>A pensioner concession card issued under section 1061ZF of the <span style={{fontStyle: 'italic'}}>Social Security Act 1991</span> of the Commonwealth</li>
                        </ul>
                        <p>Or</p>
                        <ul className="list-tile-content">
                          <li>Have been declared a class or classes of eligible person by Order published under the <span style={{fontStyle: 'italic'}}>State Concessions Act 2004</span> in the Government Gazette</li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                  <ul className="list">
                    <li className="list-tile info">
                      <div className="list-tile-content">
                        <p>You will be required to upload the supporting document(s) later in this form for the fee exemption.</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
          { formData.feePayable && formData.feeWaiverOrExemption && formData.feeWaiverOrExemption === 'waiver' && (
            <div>
              <div className="sq-form-section-description">
                <h3>Fee waiver</h3>
                <p>Please note: the statutory clock will be stopped while your fee waiver application is assessed by the Heritage Council.</p>
              </div>
              <div className="sq-form-section">
                <Field
                  name="feeWaiverActivities"
                  type="selectMultiple"
                  onSelect={(e) => {
                    if (this.props.formData.feeWaiver) {
                      let categoryExists = this.props.formData.feeWaiver.filter(item => {
                        return item.id === e.category
                      })
                      if (categoryExists.length === 0) {
                        this.props.change(`feeWaiver["${this.props.formData.feeWaiver.length}"].category`, e.category)
                      }
                    } else {
                      this.props.change(`feeWaiver[0].category`, e.category)
                    }
                  }}
                  onChange={(values) => {
                    //runs on delete - finds index and remove from array 
                    if (formData.feeWaiverActivities && formData.feeWaiverActivities.length > 0 && values.length < formData.feeWaiverActivities.length) {
                      this.props.array.remove("feeWaiver",
                        formData.feeWaiverActivities.map(item => {
                          return values.findIndex(value => value.category === item.category)
                        }).findIndex(item => item === -1)
                      )
                    }
                  }}
                  dropUp
                  component={RenderField}
                  data={TYPE_ACTIVITY_LIST}
                  valueField="id"
                  textField="category"
                  label="Categories of activity proposed in application"
                  note="Select the category (or categories) of fee waiver you wish to apply for."
                  placeholder="Add categories of proposed activities"
                  validate={required}
                  required
                  busy
                />
                { formData.feeWaiverActivities && formData.feeWaiverActivities.length > 0 && (
                  <div className="sq-form-section-description">
                    <ul className="list">
                      <li className="list-tile info">
                        <div className="list-tile-content">
                          <p>You are applying for a fee waiver. You will be required to upload the supporting document(s) later in this form applicable to the fee waiver {formData.feeWaiverActivities && formData.feeWaiverActivities.length === 1 ? 'category' : 'categories'} that {formData.feeWaiverActivities && formData.feeWaiverActivities.length === 1 ? 'has' : 'have'} been selected.</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                )}
                { formData.feeWaiverActivities && formData.feeWaiverActivities.length > 0 && (
                  <div className="sq-form-section-description">
                    <h4>Fee waiver application details</h4>
                  </div>
                )}
                { formData.feeWaiverActivities && formData.feeWaiverActivities.length > 0 && (
                  <ul className="list">
                    {formData.feeWaiverActivities.map((activity, i) => 
                      {
                        return activity.category ? (
                          <Categorydocumenttile 
                            key={i}
                            arrayPosition={
                              formData.feeWaiver.findIndex(x => {
                                return x.category === activity.category
                              })
                            }
                            formData={formData}
                            categoryTitle={activity.category}
                            categoryExample={activity.examples}
                            categoryNote={activity.note}
                          />
                        ) : null
                      }
                    )}
                  </ul>
                )}
                { formData.feeWaiverActivities && formData.feeWaiverActivities.length > 0 && (
                  <div className="sq-form-section-description">
                    <ul className="list">
                      <li className="list-tile info">
                        <div className="list-tile-content">
                          <p>You are applying for a fee waiver { feeWaiverPercentage > 0 && (<span>for <span style={{fontWeight: '600'}}>{feeWaiverPercentage.toFixed(2)}%</span></span>)} of the {formData.feePayable && (<span style={{fontWeight: '600'}}>${formData.feePayable.toLocaleString()}</span>)} permit fee.</p>
                        </div>
                      </li>
                    </ul>
                    {feeWaiverPercentage > 100 && (<p className="sq-form-error">The total percentage exceeds 100%</p>)}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="sq-form-control">
          <button type="button" className="sq-form-page-button previous" onClick={previousPage}>Previous</button>
          <button type="submit" className="sq-form-page-button next" disabled={isGetQuote || !formData.feePayable || Object.keys(this.props.quoteData).length === 0 ? 'disabled' : '' || feeWaiverPercentage > 100} onClick={jumpToError}>Next</button>
        </div>
        <div className="sq-form-control">
          <button type="button" className="sq-form-page-button" onClick={() => saveAppState(appState, formName)} disabled={isGetQuote || isAppSaving || fileUploaded(attachments)}>Save and Exit</button>
          <p className="sq-form-page-button-note">An email will be sent to Primary contact email address</p>
        </div>
      </form>
    );
  }
};

const Categorydocumenttile = props => {
  const { arrayPosition, categoryTitle, categoryExample, categoryNote } = props;

  let categoryExamples = [];
  let categoryExampleNumrows;

  if(categoryExample && categoryExample.length > 0) {
    categoryExampleNumrows = categoryExample.length;
  }

  if (categoryExampleNumrows > 0) {
    for (var j = 0; j < categoryExampleNumrows; j++) {
      categoryExamples.push(<li key={j}>{categoryExample[j]}</li>)
    }
  }

  return (
    <li key={arrayPosition} className ="list-tile">
      <div className="list-tile-content">
        <div className="list-tile-content">
          <p>{categoryTitle}</p>
          <ul>{categoryExamples}</ul>
          {categoryNote && (
            <div className="sq-form-section-description">
              <ul className="list">
                <li className="list-tile info">
                  <div className="list-tile-content">
                    <p>{categoryNote}</p>
                  </div>
                </li>
              </ul>
            </div>
          )}
          <FormSection name={`feeWaiver[${arrayPosition}]`}>
            <Field
              name="explanation"
              type="textarea"
              label="Explain why you consider this category fits the proposed works"
              component={RenderField}
              validate={required}
              required
            />
            <Field
              name="percentageOfCost"
              type="text"
              label="Do all the works fit this category or only some? Indicate the percentage based on costs of works (%)"
              component={RenderField}
              format={formatPercentage}
              normalize={normalizePercentage}
              validate={[required, percentage, percentageTwoDecimals]}
              required
            />
            <div className="hidden">
              <Field
                name="category"
                type="text"
                component={RenderField}
              />
            </div>
          </FormSection>
        </div>
      </div>
    </li>
  );
};

const mapStateToProps = (state, formName) => {
  return {
    formData: (state.form[formName.form]) ? state.form[formName.form].values : {},
    attachments: state.service.attachments,
    isAppSaving: state.app.isAppSaving,
    isGetQuote: state.service.getQuote,
    quoteData: state.service.quoteResponse,
    appState: state        
  };
};

const mapDispatchToProps = {
  saveAppState,
  getQuoteCall
};

const form = reduxForm({
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true // <------ unregister fields on unmount
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)((form)(feePayment));
